import { updateDemographicsAddress } from '../../services/updateDemographics';
import constant from './constant';


export const updateDemographicsBegin = ()=> ({
    type: constant.UPDATE_DEMOGRAPHICS_BEGIN,
});

export const updateDemographicsSuccess = ()=> ({
    type:constant.UPDATE_DEMOGRAPHICS_SUCCESS, 
   
});

export const updateDemographicsError = (error)=> ({
    type: constant.UPDATE_DEMOGRAPHICS_ERROR,
    payload: {error}
});
export const updateDemographicsCleanUp = ()=> ({
    type: constant.UPDATE_DEMOGRAPHICS_CLEANUP
});

export const updateDemographics = (address, tenantInfo)=> {
    return dispatch => {
    dispatch(updateDemographicsBegin());
    updateDemographicsAddress(address,tenantInfo);
    dispatch(updateDemographicsSuccess());

    };
};